export const state = () => ({
    history: {
        data: [],
    },
    pending: {
        data: [],
    },
    playerExchangeHistory: {
        totalPages: 0,
        total: 0,
        total_exchange_coins: 0,
        data: [],
    },
    playerActivityAndHistories: {
        total: 0,
        totalPages: 0,
        total_amount: 0,
        data: [],
    },
})

export const actions = {
    async getHistory({ commit }, params) {
        params.start_date = params.start_date + ' 00:00:00'
        const endDate = params.end_date + ' 23:59:59'
        params.end_date = this.$dayjs(endDate)
            .add(1, 'second')
            .format('YYYY-MM-DD HH:mm:ss')

        await this.$axios
            .get('/players-reward/rewards-exchange/history', { params })
            .then((data) => {
                commit('setHistory', data?.data)
            })
            .catch((_) => {})
    },
    async getPending({ commit }, params) {
        params.start_date = params.start_date + ' 00:00:00'
        const endDate = params.end_date + ' 23:59:59'
        params.end_date = this.$dayjs(endDate)
            .add(1, 'second')
            .format('YYYY-MM-DD HH:mm:ss')
        await this.$axios
            .get('/players-reward/rewards-exchange/pending-item-rewards', {
                params,
            })
            .then((data) => {
                commit('setPending', data?.data)
            })
            .catch((_) => {})
    },
    async updatePendingStatus({ commit }, { id, body }) {
        const response = await this.$axios
            .put(
                `/players-reward/rewards-exchange/pending-item-rewards/${id}`,
                body
            )
            .then((data) => {
                return true
            })
            .catch((_) => {
                return false
            })
        return response
    },
    async getPlayerExchangeHistory({ commit }, params) {
        await this.$axios
            .get(`/player-management/exchange-history/${params.player_id}`, {
                params,
            })
            .then((data) => {
                commit('setPlayerExchangeHistory', data?.data)
            })
            .catch((_) => {})
    },
    async getPlayerMissionAndActivityHistories({ commit }, data) {
        const params = {
            ...data,
        }
        delete params.player_id
        await this.$axios
            .get(
                `/player-management/activity-mission-history/${data.player_id}`,
                {
                    params,
                }
            )
            .then((data) => {
                commit('setPlayerActivityAndHistories', data?.data)
            })
            .catch((_) => {})
    },
}
export const mutations = {
    setHistory(state, data) {
        state.history = data
    },
    setPending(state, data) {
        state.pending = data
    },
    setPlayerExchangeHistory(state, data) {
        state.playerExchangeHistory = data
    },
    setPlayerActivityAndHistories(state, data) {
        state.playerActivityAndHistories = data
    },
}
